import React from 'react';
import { MousePointer2, Minus, DoorOpen, AppWindow, ArrowRightLeft, Tag, Undo2, Redo2, ZoomIn, ZoomOut, Trash2, X, Box, Camera, MapPin, SquareDashed, Eraser } from 'lucide-react';
import './planToolbar.scss';

const TOOLS = [
  { id: 'select', label: 'انتخاب', icon: MousePointer2 },
  { id: 'wall', label: 'دیوار', icon: Minus },
  { id: 'door', label: 'در', icon: DoorOpen },
  { id: 'window', label: 'پنجره', icon: AppWindow },
  { id: 'opening', label: 'بازشو', icon: ArrowRightLeft },
  { id: 'room', label: 'اتاق', icon: Tag },
  // «مرزِ فضا»: جدا کردنِ دو فضا بدونِ دیوار (پذیرایی/آشپزخانه) — کف و سقفِ جدا، بدونِ دیوار در سه‌بعدی
  { id: 'divider', label: 'مرز فضا', icon: SquareDashed },
  // جای شروعِ بازدیدِ سه‌بعدی (یک نقطه)
  { id: 'entrance', label: 'ورودی', icon: MapPin },
];

function PlanToolbar({
  activeTool,
  onToolChange,
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onZoomIn,
  onZoomOut,
  onClose,
  hasSelection,
  onDelete,
  onOpen3D,
  // «از روی کاغذ»
  onScan,
  // «پاک کردنِ کلِ پلان» (تأیید در createPlan)
  onClearPlan,
  canClear,
}) {
  return (
    <div className="plan-toolbar">
      <button type="button" className="plan-toolbar__close" onClick={onClose} aria-label="بازگشت">
        <X size={20} strokeWidth={1.8} />
      </button>

      <div className="plan-toolbar__tools">
        {TOOLS.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            type="button"
            className={`plan-toolbar__tool ${activeTool === id ? 'is-active' : ''}`}
            onClick={() => onToolChange(id)}
            aria-label={label}
          >
            <Icon size={19} strokeWidth={1.8} />
          </button>
        ))}
      </div>

      <div className="plan-toolbar__actions">
        <button
          type="button"
          className="plan-toolbar__action plan-toolbar__action--danger"
          onClick={onDelete}
          disabled={!hasSelection}
          aria-label="حذف"
        >
          <Trash2 size={17} strokeWidth={1.8} />
        </button>
        {onClearPlan && (
          <button
            type="button"
            className="plan-toolbar__action plan-toolbar__action--danger"
            onClick={onClearPlan}
            disabled={!canClear}
            aria-label="پاک کردنِ کلِ پلان"
          >
            <Eraser size={17} strokeWidth={1.8} />
          </button>
        )}
        <div className="plan-toolbar__divider" />
        <button type="button" className="plan-toolbar__action" onClick={onUndo} disabled={!canUndo} aria-label="واگرد">
          <Undo2 size={18} strokeWidth={1.8} />
        </button>
        <button type="button" className="plan-toolbar__action" onClick={onRedo} disabled={!canRedo} aria-label="ازنو">
          <Redo2 size={18} strokeWidth={1.8} />
        </button>
      </div>

      {/* بزرگ‌نمایی و «سه‌بعدی» روی صفحه‌ی رسم (پایین)، نه در نوارِ بالا — نوارِ بالا روی گوشی از عرضِ صفحه بیرون
          می‌زد و دکمه‌ی سه‌بعدی دیده نمی‌شد */}
      <div className="plan-toolbar__zoom">
        <button type="button" onClick={onZoomIn} aria-label="بزرگ‌نمایی">
          <ZoomIn size={19} strokeWidth={1.8} />
        </button>
        <button type="button" onClick={onZoomOut} aria-label="کوچک‌نمایی">
          <ZoomOut size={19} strokeWidth={1.8} />
        </button>
      </div>
      <div className="plan-toolbar__side">
        {onScan && (
          <button type="button" onClick={onScan} aria-label="پلان از روی کاغذ">
            <Camera size={19} strokeWidth={1.9} />
          </button>
        )}
      </div>
      <button type="button" className="plan-toolbar__open3d" onClick={onOpen3D} aria-label="نمای سه‌بعدی">
        <Box size={19} strokeWidth={1.9} />
        <span>سه‌بعدی</span>
      </button>
    </div>
  );
}

export default PlanToolbar;